import $ from 'jquery';
import { get } from 'common/utils/xhr';
import { scrollToElement } from 'common/utils/scroll';
import serviceDesignExpanders from 'marketing/components/serviceDesignerExpanders';

export default class ServiceDesignerFilter {
    constructor(element) {
        this.element = element;
        this.buttonSelectedAttr = 'data-button-selected';
        this.paginationLinkAttr = 'data-page-number';
        this.tabButtonAttr = 'data-service-designer-filter-tab-button';
        this.sortingSelect = element.querySelector('[data-service-designer-filter-sorting-select]');
        this.tabInputs = element.querySelectorAll('[data-service-designer-filter-tab-input]');
        this.tabButtons = element.querySelectorAll('[' + this.tabButtonAttr + ']');
        this.tabSelect = element.querySelector('[data-service-designer-filter-tab-select]');
        this.loading = document.querySelector('[data-service-designers-loading]');
        this.serviceDesigners = document.querySelector('[data-service-designers]');
        this.urlname = this.serviceDesigners.getAttribute('data-service-designers-urlname');

        this.sortingSelect.addEventListener('change', () => {
            this.getDesigners();
        });

        if (this.tabSelect) {
            this.tabSelect.addEventListener('change', (e) => {
                this.updateTabInputs(e.target.value);
                this.selectCategory(e.target.value);
            });
        }

        if (this.tabInputs) {
            for (const input of this.tabInputs) {
                input.addEventListener('change', (e) => {
                    this.selectCategory(e.target.value);
                    this.selectButton(input);
                    this.updateTabSelection(e.target.value);
                    this.getDesigners();
                });
            }
        }

        this.handlePagination();
        serviceDesignExpanders();
    }

    handlePagination() {
        const links = document.querySelectorAll(`[${this.paginationLinkAttr}]`);

        for (var i = 0; i < links.length; i++) {
            const link = links[i];

            link.addEventListener('click', (e) => {
                e.preventDefault();

                if (!link.hasAttribute('data-disabled')) {
                    scrollToElement(this.element, 15, 0);
                    const page = link.getAttribute(this.paginationLinkAttr);
                    this.getDesigners(page);
                }
            });
        }
    }

    selectCategory(categoryKey) {
        this.element.querySelector('[data-category-key]').value = categoryKey;
    }

    get categoryKey() {
        return this.element.querySelector('[data-category-key]').value;
    }

    get sortingKey() {
        return this.sortingSelect[this.sortingSelect.selectedIndex].value;
    }

    getDesigners(page = 1) {
        this.startLoading();

        const request = get(this.element.getAttribute('action')).query({
            category_key: this.categoryKey,
            sorting_key: this.sortingKey,
            urlname: this.urlname,
            page: page,
        });

        request.end((err, res) => {
            if (!err) {
                this.serviceDesigners.innerHTML = res.text;
                serviceDesignExpanders();
                this.handlePagination();
                this.stopLoading();
            }
        });
    }

    startLoading() {
        this.loading.removeAttribute('data-hidden');
    }

    stopLoading() {
        this.loading.setAttribute('data-hidden', '');
    }

    selectButton(input) {
        for (const button of this.tabButtons) {
            button.removeAttribute(this.buttonSelectedAttr);
        }

        $(input)
            .closest('[' + this.tabButtonAttr + ']')
            .attr(this.buttonSelectedAttr, true);
    }

    updateTabSelection(value) {
        $(this.tabSelect).val(value);
    }

    updateTabInputs(value) {
        $(this.tabInputs).filter(`[value="${value}"]`).trigger('click');
    }

    static create(selector='[data-service-designer-filter]') {
        const filter = document.querySelector(selector)

        new ServiceDesignerFilter(filter);
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/ServiceDesignerFilter.js